import loginImage from "@doar/shared/images/img16.png";
import AffiliateForm from "../../components/affiliate-form";
import {
    StyledMedia,
    StyledMediaBody,
    StyledImage,
    StyledSignin,
} from "./style";

const AuthContainer = () => {
    return (
        <StyledMedia>
            <StyledSignin>
                <AffiliateForm />
            </StyledSignin>
            <StyledMediaBody>
                <StyledImage>
                    <img src={loginImage} alt="Afiliarse" />
                </StyledImage>
            </StyledMediaBody>
        </StyledMedia>
    );
};

export default AuthContainer;
